// extracted by mini-css-extract-plugin
export default {"box":"box--ulgUF","contactsSectionWrapper":"contactsSectionWrapper--iBWkd","items":"items--lfprN","item":"item--C9QLD"};